import { render, staticRenderFns } from "./Styleguide.vue?vue&type=template&id=4ca8e874&scoped=true&"
var script = {}
import style0 from "./Styleguide.vue?vue&type=style&index=0&id=4ca8e874&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca8e874",
  null
  
)

export default component.exports